// extracted by mini-css-extract-plugin
export var box = "projectOverviewHorizontal-module--box--c4a15";
export var buttonHolder = "projectOverviewHorizontal-module--buttonHolder--8490a";
export var flexbox = "projectOverviewHorizontal-module--flexbox--63796";
export var gatsbyRespImageBackgroundImage = "projectOverviewHorizontal-module--gatsby-resp-image-background-image--336bc";
export var gatsbyRespImageLink = "projectOverviewHorizontal-module--gatsby-resp-image-link--2efe2";
export var input = "projectOverviewHorizontal-module--input--60ddb";
export var load8 = "projectOverviewHorizontal-module--load8--87ce2";
export var loader = "projectOverviewHorizontal-module--loader--f65b3";